import { Priority } from "../../Enums/ChoiceEnums";
import { ApiResponseSimple, postObject } from "../ChoiceApi";
import { assertInternally } from "../Environment";
import { IListByNameExportItem } from "../Models/SearchModel";


export enum EDocumentLocationType
{
    Patient,
    Company,
    Practice,
    Resource,
    Payer
}

export interface SaveEDocumentInput
{
    base64Data: string,
    documentName: string,
    documentComment?: string,
    folderId?: number,
    receivedDate?: string,  // Date string
    documentTypeId?: number,

    communicationUserType?: EDocumentCommunicationUserType,
    communicationUserId?: number,

    reviewInfo?: IReviewInfo
}

export enum EDocumentCommunicationUserType
{
    User = "U",
    UserGroup = "G"
}

export interface ISaveEDocument
{
    isSuccess: boolean,
    errorMessage?: string,
    documentId?: number
}

export interface IReviewInfo
{
    // Review data
    message?: string,
    priority: Priority,
    reviewers?: IListByNameExportItem[]
}
